<template>
  <div class="title-group"
       :class="{'is-bar': bar, 'is-bold': bold, 'is-fold': fold, 'edit-mode': editMode}">
    <div class="header">
      <div class="title" :class="{'line': line, 'dash-line': dashLine}">
        <div v-if="bar"
             class="bar theme-bg"></div>
        <slot name="title">
          <span>{{title}}</span>
        </slot>
      </div>
      <div class="extra">
        <template v-if="fold">
          <el-button size="mini"
                     type="text"
                     @click="toggleFold">
            <i :class="['el-icon-caret-top', {'fold': isFold}]"></i>
            <span>{{isFold ? '展开' : '折叠'}}</span>
          </el-button>
        </template>
        <template v-else>
          <slot name="extra"></slot>
        </template>
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="!isFold"
           class="main">
        <template v-if="editMode && $slots.edit">
          <slot name="edit"></slot>
        </template>
        <template v-else>
          <slot></slot>
        </template>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'TitleGroup',
  props: {
    title: String,
    editMode: false,
    bar: {
      type: Boolean,
      default: true
    },
    line: Boolean,
    dashLine: Boolean,
    bold: {
      type: Boolean,
      default: true
    },
    fold: Boolean
  },
  data () {
    return {
      isFold: false
    }
  },
  methods: {
    toggleFold () {
      this.isFold = !this.isFold
    }
  }
}
</script>

<style lang="scss">
  .title-group {
    &.is-bar {
      & > .header {
        & > .title {
          padding-left: 12px;
        }
      }
    }
    &.is-bold {
      & > .header {
        & > .title {
          font-weight: bold;
        }
      }
    }
    &.is-fold {
      & > .header {
        padding: 4px 12px;
        background-color: #f3f4f5;
        margin-bottom: 1px;
        & > .title {
          padding-left: 0!important;
          display: flex;
          align-items: center;
          & > .bar {
            display: none;
          }
        }
        & > .extra {
          .el-button {
            color: #606266;
            i {
              transition: transform .3s;
              &.fold {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
      & > .main {
        padding-left: 0!important;
      }
    }
    & > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > .title {
        flex: auto;
        position: relative;
        color: #606266;
        font-size: 12px;
        & > .bar {
          position: absolute;
          left: 0;
          top: 50%;
          width: 3px;
          height: 10px;
          margin-top: -5px;
        }
        i {
          margin-right: 5px;
          font-size: 14px;
        }
        &.line,
        &.dash-line {
          display: flex;
          align-items: center;
          &:after {
            content: '';
            flex: auto;
            height: 1px;
            background-color: #ddd;
            margin-left: 14px;
          }
        }
        &.dash-line {
          &:after {
            background: linear-gradient(to right, #ddd 0%, #ddd 70%, transparent 70%) repeat-x!important;
            background-size: 14px 1px!important;
          }
        }
      }
      & > .extra {
        flex: none;
      }
    }
    & > .main {
      margin-top: 15px;
    }
  }
</style>
